export default "__VITE_ASSET__DRkD_Kgs__"